export const GET_WALLET_MANAGEMENT_LIST = null;
export const SELECTED_WALLET_MANAGEMENT_ID = null;